module.exports = __webpack_public_path__ + "static/Copper_Dragon-0f518856950daa8c63ee5fa28cb44d9a.jpg";